import React from 'react';
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { loginRedirect } from '../utils';

function LoginRedirect() {
  var config = useConfig();
  loginRedirect(config.accountsUrl);
  return React.createElement(React.Fragment, null, "Redirecting to login screen...");
}

export default LoginRedirect;